import CryptoJS from "crypto-js";

// ⚠️ Ideally, store this key in a .env file, not in code
const SECRET_KEY = "SkcSolution@1984";

export const encryptData = (data) => {
  try {
    const stringData = typeof data === "string" ? data : JSON.stringify(data);
    const ciphertext = CryptoJS.AES.encrypt(stringData, SECRET_KEY).toString();
    return ciphertext;
  } catch (error) {
    console.error("Encryption failed:", error);
    return null;
  }
};

export const decryptData = (ciphertext) => {
    try {
      // Remove accidental double quotes if present
      if (ciphertext.startsWith('"') && ciphertext.endsWith('"')) {
        ciphertext = ciphertext.slice(1, -1);
      }
  
      const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
  
      if (!decrypted) {
        throw new Error("Invalid secret key or corrupted ciphertext");
      }
  
      return JSON.parse(decrypted);
    } catch (error) {
      console.error("Decryption failed:", error.message);
      return null;
    }
  };
